import { Location } from 'history';

import windowsSocialImage from '../../images/www/windows_social.jpg';

import { IHeadData } from '../../resources/types/head_data';

const BASE_KEYWORDS: string[] = [
  'Clutter',
  'Storage',
  'Moving',
  'Pickup',
  'Return',
  'Los Angeles',
  'San Francisco',
  'San Diego',
  'Orange County',
  'New York',
  'Seattle',
  'Chicago',
  'Philadelphia',
];

const HOME_KEYWORDS: string[] = [
  'Moving and Storage Company',
  'Moving and Storage Units',
  'Storage Unit Moving Company',
  'Movers to Storage Unit',
  'Moving Storage Facilities',
  'Storage and Moving Units',
  'Advanced Moving and Storage',
  'Affordable Moving & Storage',
  'Professional Moving & Storage',
  'Moving & Storage Solutions',
  'Moving and Storage Solutions',
  'Advantage Moving and Storage',
  'Moving Storage Solutions',
];

const BOOK_STORAGE_KEYWORDS: string[] = [
  'Portable Storage Containers for Rent',
  'Portable Storage Units for Rent',
  'Rent Portable Storage',
  'Storage Unit Quote',
  'Cost Of Portable Storage Units',
  'Portable Storage Units Prices',
  'Storage Quotes',
  'Quote Storage',
  'Storage Quote',
  'Book Storage Online',
];

const BOOK_MOVING_KEYWORDS: string[] = [
  'Moving in Quote',
  'Moving Quotes',
  'Moving Quote',
  'Cost for Movers Cross Country',
  'Shipping Container Moving Cost',
  'Book Movers Online',
  'Moving Container Quotes',
  'Movers Book Online',
];

const KEYWORDS_META = {
  name: 'keywords',
  content: BASE_KEYWORDS.join(', '),
};

const DEFAULT_HEAD_DATA = { title: 'Clutter', meta: [] };

const imgUrl = (path: string) => `https:${path}`;

const HEAD_DATA: { [path: string]: IHeadData } = {
  '/': {
    title: 'Clutter by Iron Mountain · Full-service storage',
    meta: [
      {
        name: 'keywords',
        content: BASE_KEYWORDS.concat(HOME_KEYWORDS).join(', '),
      },
      {
        property: 'og:image',
        content: imgUrl(windowsSocialImage),
      },
      {
        name: 'description',
        content:
          'Full-service storage backed by Iron Mountain. We pick up, catalog, and store your belongings. Request delivery anytime from your phone.',
      },
      {
        property: 'og:description',
        content:
          'Full-service storage backed by Iron Mountain. We pick up, catalog, and store your belongings. Request delivery anytime from your phone.',
      },
      {
        property: 'og:title',
        content: 'Clutter by Iron Mountain · Full-service storage',
      },
    ],
  },
  '/getstarted': {
    title: 'Clutter Storage - We Pick It Up, Store It and Bring It Back',
    meta: [
      {
        property: 'robots',
        content: 'noindex,nofollow',
      },
    ],
  },
  '/help': {
    title: 'Clutter | Help',
    meta: [
      KEYWORDS_META,
      {
        property: 'og:image',
        content: imgUrl(windowsSocialImage),
      },
      {
        name: 'description',
        content:
          'How does Clutter work? It’s simple. We come to you, pack and pick up your stuff, then take it ' +
          'to our storage facility. Need something back? We deliver it back whenever, wherever.',
      },
      {
        property: 'og:description',
        content:
          'Clutter is a convenient, local storage solution that provides free item pick up and delivery. ' +
          'It’s the simplest way to store what matters to you.',
      },
      {
        property: 'og:title',
        content: 'Clutter | Help',
      },
    ],
  },
  '/locations': {
    title: 'Clutter | Locations',
    meta: [
      KEYWORDS_META,
      {
        property: 'og:image',
        content: imgUrl(windowsSocialImage),
      },
      {
        name: 'description',
        content:
          'Moving & storage available nationwide. Bay Area. Chicago. Los Angeles. New Jersey. New York. ' +
          'Philadelphia. Orange County. San Diego. Seattle. Inland Empire.',
      },
      {
        property: 'og:description',
        content:
          'Moving & storage available nationwide. Bay Area. Chicago. Los Angeles. New Jersey. New York. ' +
          'Philadelphia. Orange County. San Diego. Seattle. Inland Empire.',
      },
      {
        property: 'og:title',
        content: 'Clutter | Locations',
      },
    ],
  },
  '/legal/tos': {
    title: 'Clutter | Terms of Use',
    meta: [
      {
        property: 'og:title',
        content: 'Clutter | Terms of Use',
      },
      {
        property: 'og:image',
        content: imgUrl(windowsSocialImage),
      },
    ],
  },
  '/legal/privacy_policy': {
    title: 'Clutter | Privacy Policy',
    meta: [
      {
        property: 'og:title',
        content: 'Clutter | Privacy Policy',
      },
      {
        property: 'og:image',
        content: imgUrl(windowsSocialImage),
      },
    ],
  },
  '/legal/california_privacy_rights': {
    title: 'Clutter | California Privacy Rights',
    meta: [
      {
        property: 'og:title',
        content: 'Clutter | California Privacy Rights',
      },
      {
        property: 'og:image',
        content: imgUrl(windowsSocialImage),
      },
    ],
  },
  '/legal/limited_security_warranty': {
    title: 'Clutter | Limited Security Warranty',
    meta: [
      {
        property: 'og:title',
        content: 'Clutter | Limited Security Warranty',
      },
      {
        property: 'og:image',
        content: imgUrl(windowsSocialImage),
      },
    ],
  },
  '/legal': {
    title: 'Clutter | Legal',
    meta: [
      {
        property: 'og:title',
        content: 'Clutter | Legal',
      },
      {
        property: 'og:image',
        content: imgUrl(windowsSocialImage),
      },
    ],
  },
  '/book/moving': {
    title: 'Clutter | Book Moving',
    meta: [
      {
        name: 'keywords',
        content: BASE_KEYWORDS.concat(BOOK_MOVING_KEYWORDS).join(', '),
      },
    ],
  },
  '/book/storage': {
    title: 'Clutter | Book Storage',
    meta: [
      {
        name: 'keywords',
        content: BASE_KEYWORDS.concat(BOOK_STORAGE_KEYWORDS).join(', '),
      },
    ],
  },
};

HEAD_DATA[''] = HEAD_DATA['/']; // slash is missing for root in SSR

export const resolveHeadData = (location: Location) => {
  const headData = HEAD_DATA[location.pathname];

  if (headData) {
    return {
      ...headData,
      meta: headData.meta || [],
      link: headData.link || [],
    };
  } else {
    return DEFAULT_HEAD_DATA;
  }
};
